import { type ISeriesAssociation } from '@/types/series.types';
import { Post } from '../helpers';
import { SeriesPath } from './path';

export default function SetSeriesEvents({
  channel,
  seriesUuid,
  eventUuids,
}: {
  channel: number;
  seriesUuid: string;
  eventUuids: string[];
}) {
  return Post<ISeriesAssociation>({
    path: SeriesPath(channel, `/${seriesUuid}/events`),
    body: { eventUuids },
  });
}
